var map = {
	"./2018-03-04/whats-new.html": 1908,
	"./2018-04-12/whats-new.html": 1909,
	"./2018-04-24/whats-new.html": 1910,
	"./2018-05-23/whats-new.html": 1911,
	"./2018-05-31/whats-new.html": 1912,
	"./2018-07-04/whats-new.html": 1913,
	"./2018-07-19/whats-new.html": 1914,
	"./2018-11-20/whats-new.html": 1915,
	"./2019-04-04/whats-new.html": 1916,
	"./2020-01-21/whats-new.html": 1917,
	"./2020-07-18/whats-new.html": 1918
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1907;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update ^\.\/.*\/whats\-new\.html$
// module id = 1907
// module chunks = 0